import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from './translation/en.json';
import translationTH from './translation/th.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  th: {
    translation: translationTH
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;